module.exports = __webpack_public_path__ + "img/portrait-earbuds-music.efcd4cd6.svg";